import { __decorate } from "tslib";
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
export const SpaceRecentListModel = Symbol('SpaceRecentListModel');
let SpaceRecentListModelImpl = class SpaceRecentListModelImpl extends AbstractModel {
    constructor() {
        super(...arguments);
        this._modelData = [];
    }
    dispose() {
        this.update(() => []);
    }
};
SpaceRecentListModelImpl = __decorate([
    injectable()
], SpaceRecentListModelImpl);
export { SpaceRecentListModelImpl };
